<div
    [pTooltip]="tooltipText()"
    [tooltipOptions]="{ showDelay: 150, tooltipEvent: 'hover' }"
    class="pointer-events-auto!">
    <a
        #routeActive="routerLinkActive"
        class="group flex min-h-10 w-full items-center px-1 text-(--p-navigation-item-color) focus-visible:outline-none"
        routerLinkActive
        ariaCurrentWhenActive="page"
        [routerLink]="disabled() ? null : route()"
        [routerLinkActiveOptions]="routeMatchOptions"
        [class.opacity-50]="disabled()"
        [attr.aria-disabled]="disabled() || null"
        [attr.aria-keyshortcuts]="shortcut()"
        [attr.aria-label]="label()"
        [attr.data-testid]="testId()"
        [attr.tabindex]="disabled() ? -1 : null"
        (click)="preventDisabledNavigation($event)">
        <span
            class="flex h-9 w-full items-center gap-3 rounded-md px-2 transition-colors group-focus-visible:ring-1 group-focus-visible:ring-(--p-primary-color)"
            [class.justify-center]="iconOnly()"
            [ngClass]="{
                'group-hover:bg-(--p-navigation-item-focus-background)': !disabled(),
                'group-hover:text-(--p-navigation-item-focus-color)': !disabled(),
                'bg-(--p-navigation-item-active-background)': routeActive.isActive,
                'text-(--p-navigation-item-active-color)': routeActive.isActive,
            }">
            <span class="flex h-5 w-5 shrink-0 items-center justify-center" aria-hidden="true">
                <ng-content />
            </span>
            @if (!iconOnly()) {
                <span class="mt-1 min-w-0 truncate">{{ label() }}</span>
                @if (shortcut()) {
                    <span
                        class="border-surface bg-emphasis text-muted-color ml-auto w-11 shrink-0 rounded border p-1 text-center text-xs">
                        {{ shortcut() }}
                    </span>
                }
            }
        </span>
    </a>
</div>
